import React, { useState, useEffect, useRef, lazy } from 'react';
import DataTable from '../../../../Components/UiComponents/DataTable';
import { getCustomerControlField } from '../../../../Services/customerServices';
import HeaderSearchBar from '../../../../Components/UiComponents/HeaderSearchBar';
import ToastElement from '../../../../Components/UiComponents/ToastElement';
import { getField } from '../../../../Services/tooltipService';
import _ from 'lodash';
import { getControlField } from "../../../../Services/tooltipService";
import { getSurvey } from '../../../../Services/surveyData';
import { useNavigate } from 'react-router-dom';

export default function CompletionTracker(props) {
  const [customerId, setCustomerId] = useState(null);
  const [customerControlFields, setCustomerControlFields] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [deleteIds, setDeleteIds] = useState([]);
  const [pipModuleData, setPipModuleData] = useState([]);
  const toastRef = useRef();
  const [clientModuleData, setClientModuleData] = useState();
  const [surveyData, setSurveyData] = useState([]);
  const navigate = useNavigate()
  useEffect(() => {
    // Fetching end user data from local storage
    const enduserStr = localStorage.getItem("enduser");

    // Checking if end user data exists in local storage
    if (enduserStr) {
      // Parsing end user data
      const enduser = JSON.parse(enduserStr);
      // Extracting customer information from end user data
      const customer = enduser.customer;

      // Setting customer ID state
      setCustomerId(customer);
    } else {
      // Logging if no end user data found in local storage
      navigate("/login")
      localStorage.clear()
    }
  }, []);

  useEffect(() => {
    // Fetching customer field data
    getSurveyField();
    // Fetching customer control data
    getCustomerControl();
    pipelineModuleData();
    controlFields();
  }, [customerId]);


  const pipelineModuleData = async () => {
    try {
      if (customerId === null) {
        return;
      }
      const response = await getField(customerId);
      setPipModuleData(response?.data?.cust[0]);
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    }
  };

  const controlFields = async () => {
    try {
      if (customerId === null) {
        return;
      }
      const clientModuleDataResponse = await getControlField(customerId);
      setClientModuleData(clientModuleDataResponse?.data?.cust[0]?.modules[0]);
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    }
  }

  useEffect(() => {
    // Fetching customer field data
    getSurveyField();
  }, [])

  // Function to fetch customer fields data from the server
  const getSurveyField = async () => {
    // Ensure customerId is not null
    try {
      if (customerId === null) {
        return;
      }
      if (customerId !== null) {
        // Fetch customer data from the server
        const getSurveyData = await getSurvey(customerId);
        setSurveyData(getSurveyData?.data?.completionTrackerData);
      }
    }
    catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: "Failed to fetch customer fields"
      });
    }
  }

  // Function to fetch and set customer control fields data
  const getCustomerControl = async () => {
    try {
      if (customerId === null) {
        return;
      }
      // Check if customerId is available
      if (customerId !== null) {
        const customerData = await getCustomerControlField(customerId);

        // Extract and set customer control fields
        const controlFields = customerData?.data?.cust[0].modules[0];
        setCustomerControlFields(controlFields);
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    }
  };

  const checkingDisplayName = (rowData) => {
    return (
      <div>
        {
          <div className='fs-12 w-50'>
            {rowData.survey_name != null && rowData.survey_name != '' ? rowData.survey_name : rowData.survey_name}
          </div>
        }
      </div>
    )
  }
  const draftedAt = (rowData) => {
    return (
      <div className='fs-12 w-20'>
        {
          <div>
            {(rowData.drafteded_at)}
          </div>
        }
      </div>
    )
  }


  const surveyCount = (rowData) => {
    return (
      <div className='fs-12'>
        {
          <div>
            {rowData.surveyCount}%
          </div>
        }
      </div>
    );
  }


  // Define column configuration for the data table
  const columns = [
    {
      field: "survey_name", // Field name for the column data
      header: _.find(clientModuleData?.tabs[21].tables[0].headers, { header_name: "Survey" })?.display_name, // Header text displayed in the table header
      body: checkingDisplayName, // Function to render the cell content for this column
      style: { width: "40%" },
      headerClassName: "header-datatable",
      className: 'row-datatable'
    },
    {
      field: "drafteded_at",
      header: _.find(clientModuleData?.tabs[21].tables[0].headers, { header_name: "Updated Date" })?.display_name,
      body: draftedAt,
      headerClassName: "header-datatable",
      className: 'row-datatable'
    },
    {
      field: "surveyCount",
      header: _.find(clientModuleData?.tabs[21].tables[0].headers, { header_name: "Completion Status" })?.display_name,
      body: surveyCount,
      headerClassName: "header-datatable",
      className: 'row-datatable'
    }
  ];

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    filteredQuestionsArray(e.target.value)
  };
  const handleClearFilter = () => {
    setSearchQuery("");
    filteredQuestionsArray("");
    getSurveyField()
  };

  /**
  * Filters the customer reference data based on the provided query.
  * If the query is empty, it retrieves the full customer field data.
  * 
  * @param {string} query - The search query to filter the customer reference data.
  */
  const filteredQuestionsArray = (query) => {
    // Check if the query is not empty
    if (query.length > 0) {
      // Convert the query to lowercase for case-insensitive comparison
      const lowerCaseQuery = query.toLowerCase();

      // Filter the customer reference data
      const filteredData = surveyData?.filter(item => {
        // Check if any value in the item includes the query string
        return Object.values(item).some(value =>
          value.toString().toLowerCase().includes(lowerCaseQuery)
        );
      });

      // Update the state with the filtered data
      setSurveyData(filteredData);

      // Log the filtered data for debugging purposes
    } else {
      // If the query is empty, retrieve the full customer field data
      getSurveyField();
    }
  };

  /**
  * Removes a field from the customer reference data at the specified index.
  * @param {number} selectedIndex - The index of the field to be removed.
  * @param {Object} data - The updated data to be set after removal.
  */

  const removeField = async (selectedIndex, data) => {
    // Check if the selectedIndex is valid
    if (selectedIndex === -1) {
      return;
    }
    // selected Ids for deletion
    setDeleteIds(data.map(item => (
      item._id
    )))
  };

  const rowClick = async (data) => {
  };

  return (
    <div className="group-table-component">
      <ToastElement ref={toastRef} />
      <div>
        <p className="fs-16 fw-600 mar-b-3">{_.find(customerControlFields?.tabs, { tab_name: "Completion Tracker" })?.display_name}</p>
        <p className="group-table-text-section">
          Track all current Surveys
        </p>
      </div>
      <div className="group-table-buttons">
        <div className="delete-button"></div>
        <div className="group-table-search">
          <HeaderSearchBar
            value={searchQuery}
            onChange={(e) => handleSearchChange(e)}
            onClick={handleClearFilter}
          />
        </div>
      </div>
      <div className='mt-20'>
        <DataTable
          value={surveyData}
          columns={columns}
          searchQuery={searchQuery}
          removeField={removeField}
          rowClick={rowClick}
          isNewField={true}
        />
      </div>
    </div>
  )
}